import InitialOtherLegalDamaged from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/otherDamaged/initialOtherLegalDamaged';
import InitialOtherRealDamaged from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/otherDamaged/initialOtherRealDamaged';
import { OtherDamagedInfoType } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/otherDamagedInfo/OtherDamagedInfo.type';
import { useFormContext } from 'react-hook-form';

const InitialOtherDamaged = () => {
  const methods = useFormContext<OtherDamagedInfoType>();
  const isLegal =
    methods.watch('personal_information.owner_type') === 'legal' || false;
  return isLegal ? <InitialOtherLegalDamaged /> : <InitialOtherRealDamaged />;
};
export default InitialOtherDamaged;
